import { supo } from '../api';
import ActionTypes from '../constants/ActionTypes';

export const fetchHomepageData = () => {
  return async dispatch => {
    try {
      const { data } = await supo.get(`/homepage`);
      return dispatch({
        type: ActionTypes.FETCH_HOMEPAGE_DATA_SUCCESS,
        payload: data
      });
    } catch (error) {
      console.error(error);
    }
  };
};
